import { FocusManager } from '../services/focus-manager';

export function swFocusEmpty(sharedModule) {
  /**
   * Directive that sets fields for application-managed-focus
   */
  sharedModule.directive(
    'swFocusEmpty',
    ($timeout: ng.ITimeoutService, focusManager: FocusManager) => ({
      restrict: 'A',
      require: 'ngModel',

      link: function postLink(scope, element, attrs, $ctrl) {
        let getterCounter: number,
          getter = () => {
            if (getterCounter === 0) {
              getterCounter += 1;
              return '';
            }

            return $ctrl.$viewValue;
          },
          setter = (value) => {
            $ctrl.$setViewValue(value);
            $ctrl.$render();
          };

        element.on('focus', () => {
          getterCounter = 0;

          $timeout(() => {
            element[0].select();
          });

          focusManager.set(getter, setter);
        });

        element.on('keydown', () => {
          getterCounter = 1;
        });

        scope.$on('$destroy', () => {
          focusManager.reset();
          getter = null;
          setter = null;
        });
      },
    }),
  );
}
